import React from "react";
import "../styles/Internships.css";
import Apple from "../assets/Apple.svg";
import Byers from "../assets/Byers.svg";

function Internships() {
  return (
    <section id="work" className="portfolio-section">
      <h2>Work Experience</h2>
      <div className="portfolio-items">
        <div className="portfolio-item">
          <img src={Apple} alt="Apple" class="internship" />
          <div className="internship-text">
            <p class="project-name">Apple: Engineering Program Manager</p>
            <d class="project-description">
              {" "}
              FaceTime/SharePlay PM to drive iOS 18 release, and created a new
              process-automation tool on the way.
            </d>
          </div>
        </div>
        <div className="portfolio-item">
          <img src={Byers} alt="Byers" class="internship" />
          <div className="internship-text">
            <p class="project-name">
              Stanford Biodesign: Cardiovascular Imaging
            </p>
            <d class="project-description">
              Refining congenital heart models to improve cardiac surgical
              simulation with SimVascular in the Marsden Lab.
            </d>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Internships;
